import styled from "styled-components";
import Button from "common/Buttons/Button";
import type { ButtonProps } from "antd";
import useKeyPressWithCallback from "utils/hooks/useKeyPressWithCallback";

interface SubmitButtonProps extends ButtonProps {
  submitOnEnter?: boolean;
}

const SubmitButton = ({
  children,
  disabled,
  loading,
  submitOnEnter = true,
  onClick,
  ...props
}: SubmitButtonProps) => {
  useKeyPressWithCallback(
    "Enter",
    !submitOnEnter || disabled || loading ? undefined : (onClick as () => void)
  );

  return (
    <StyledButton
      type="primary"
      $size="l"
      disabled={disabled}
      loading={loading}
      onClick={onClick}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default SubmitButton;

const StyledButton = styled(Button)`
  margin-top: 30px;
  width: 100%;
`;
